import { createSelector, createSlice } from '@reduxjs/toolkit';

import { subscribeToNewsletter } from '@/redux/epics/newsletter.epics';
import type { RootState } from '@/redux/create-store';

type InitialState = {
  subscriptionRequestStatus: 'succeeded' | 'errored' | 'idle'
}

const initialState: InitialState = {
  subscriptionRequestStatus: 'idle'
};
export const newsletterSlice = createSlice({
  name: 'newsLetter',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(subscribeToNewsletter.pending, (state) => {
      state.subscriptionRequestStatus = 'idle';
    });

    builder.addCase(subscribeToNewsletter.fulfilled, (state) => {
      state.subscriptionRequestStatus = 'succeeded';
    });

    builder.addCase(subscribeToNewsletter.rejected, (state) => {
      state.subscriptionRequestStatus = 'errored';
    });
  }
});

export default newsletterSlice.reducer;

const newsLetterState = (state: RootState) => state.newsletter;

export const selectNewsletterSubscriptionRequestStatus = createSelector(
  [newsLetterState],
  (state) => state.subscriptionRequestStatus
);
